export const SUPPORTED_LANGUAGES = Object.freeze(["en", "de", "fr", "it"]);